import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const EvaluationCoursService = {
  async getAllEvaluations() {
    try {
      const result = await axios.get(`${apiUrl}/EvaluationCours`);
      return result.data;
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des évaluations",
        data: []
      };
    }
  },

  async createEvaluation(data) {
    try {
      const result = await axios.post(`${apiUrl}/EvaluationCours`, data);
      return result.data;
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la création de l'évaluation",
        data: null
      };
    }
  },

  async updateEvaluation(id, data) {
    try {
      const result = await axios.post(`${apiUrl}/EvaluationCours/update/${id}`, data);
      return result.data;
    } catch (error) {
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la mise à jour de l'évaluation",
        data: null
      };
    }
  }
};

export default EvaluationCoursService;
